import React from 'react'

function getPages(page, totalPages) {
    const pages = []
    const start = Math.max(1, page - 2)
    const end = Math.min(totalPages, page + 2)

    for (let current = start; current <= end; current += 1) {
        pages.push(current)
    }

    return pages
}

function AdminPagination({ page, totalPages, total, limit, onPageChange }) {
    if (!total || totalPages <= 1) return null

    const from = (page - 1) * limit + 1
    const to = Math.min(page * limit, total)

    return (
        <div className="adminPagination">
            <span className="adminPagination__summary">
                Показано {from}-{to} из {total}
            </span>

            <div className="adminPagination__controls">
                <button
                    type="button"
                    disabled={page <= 1}
                    onClick={() => onPageChange(page - 1)}
                >
                    Назад
                </button>

                {page > 3 && (
                    <>
                        <button type="button" onClick={() => onPageChange(1)}>1</button>
                        <span>...</span>
                    </>
                )}

                {getPages(page, totalPages).map((item) => (
                    <button
                        key={item}
                        type="button"
                        className={item === page ? 'adminPagination__page--active' : ''}
                        onClick={() => onPageChange(item)}
                    >
                        {item}
                    </button>
                ))}

                {page < totalPages - 2 && (
                    <>
                        <span>...</span>
                        <button type="button" onClick={() => onPageChange(totalPages)}>{totalPages}</button>
                    </>
                )}

                <button
                    type="button"
                    disabled={page >= totalPages}
                    onClick={() => onPageChange(page + 1)}
                >
                    Вперед
                </button>
            </div>
        </div>
    )
}

export default React.memo(AdminPagination)
